import { render } from "./Entry.vue?vue&type=template&id=6deeecbb"
import script from "./Entry.vue?vue&type=script&lang=js"
export * from "./Entry.vue?vue&type=script&lang=js"
script.render = render

export default script